export const TEXTS = {
  REQUEST_REPORT_BUTTON_TEXT: 'Запросить отчет',
  REQUEST_EARLY_REPORT_BUTTON_TEXT: 'Запросить досрочный отчет',
  REQUEST_EARLY_REPORT_MENU_ITEM: 'Досрочный отчет',
  REQUEST_BY_DAYS_REPORT_MENU_ITEM: 'Отчет по дням',
};
